import React, { useRef, useEffect, useCallback, useState } from "react";
import { storage, firestore } from "firebase";
import { Button, TextField } from "@material-ui/core";
import { KeyboardVoice, MicOff, Publish } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "400px",
    margin: "auto",
    marginTop: 40,
  },
  margin: {
    marginBottom: "16px",
  },
  audio: {
    marginBottom: "16px",
    width: "100%",
  },
}));

export default function Record(props) {
  const styles = useStyles();
  const storageRef = storage().ref();

  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const blobRef = useRef(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [recording, setRecording] = useState(false);
  const [audioRecordingDetails, setAudioRecordingDetails] = useState(null);
  const [author, setAuthor] = useState("");
  const [location, setLocation] = useState("");
  const [error, setError] = useState(null);

  function createAudio() {
    const blob = new Blob(chunksRef.current, {
      type: "audio/ogg; codecs=opus",
    });
    blobRef.current = blob;

    chunksRef.current = [];
    const audioURL = window.URL.createObjectURL(blob);
    setAudioUrl(audioURL);
    console.log(audioURL);
    props.endCallback();
  }

  function uploadAudio() {
    props.uploadingCallback();
    const fileName =
      props.question.name + "-" + audioUrl.split("/").pop() + audioUrl.length;
    const filePath = `audio/${fileName}`;

    const audioRef = storageRef.child(filePath);
    audioRef
      .put(blobRef.current)
      .then((snapshot) => {
        console.log("Uploaded", snapshot);
        return snapshot.ref.getDownloadURL();
        //   setAudioRemoteUrl(snapshot.ref.getDownloadURL());
      })
      .then((url) => {
        console.log(url);
        setAudioRecordingDetails({ url: url, prompt: props.question.prompt });
        return firestore().collection("answers").add({
          question_id: props.question.id,
          url,
          path: filePath,
          author,
          location,
        });
      })
      .then((ref) => {
        const answerId = ref.id;
        return firestore()
          .collection("questions")
          .doc(props.question.id)
          .update({
            answers: firestore.FieldValue.arrayUnion(answerId),
          });
      })
      .then(() => {
        props.savedCallback();
      })
      .catch((error) => {
        props.savedCallback();
        console.log(error);
        setError("There was an error ", error);
      });
  }

  function getUserMedia() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      console.log("getUserMedia supported.");
      navigator.mediaDevices
        .getUserMedia(
          // constraints - only audio needed for this app
          {
            audio: true,
          }
        )

        // Success callback
        .then(function (stream) {
          console.log(stream);
          mediaRecorderRef.current = new MediaRecorder(stream);

          mediaRecorderRef.current.ondataavailable = (e) => {
            chunksRef.current.push(e.data);
          };

          mediaRecorderRef.current.onstop = function (e) {
            console.log("recorder stopped triggered");

            // const clipName = prompt("Enter a name for your sound clip");

            createAudio();

            // uploadAudio();
          };
        })

        // Error callback
        .catch(function (err) {
          console.log("The following getUserMedia error occured: " + err);
        });
    } else {
      console.log("getUserMedia not supported on your browser!");
    }
  }

  useEffect(() => {
    getUserMedia();
  }, []);

  return (
    <div className={styles.container}>
      <Button
        variant="contained"
        color={audioUrl == null ? "primary" : "default"}
        className={styles.margin}
        startIcon={
          mediaRecorderRef.current != null &&
          mediaRecorderRef.current.state === "recording" ? (
            <MicOff />
          ) : (
            <KeyboardVoice />
          )
        }
        onClick={() => {
          if (mediaRecorderRef.current != null) {
            if (mediaRecorderRef.current.state === "recording") {
              mediaRecorderRef.current.stop();
              setRecording(false);
              console.log(mediaRecorderRef.current.state);
              console.log("recorder stopped");
            } else {
              props.startCallback();
              mediaRecorderRef.current.start();
              setRecording(true);
              console.log(mediaRecorderRef.current.state);
              console.log("recorder started");
            }
          }
        }}
      >
        {recording ? "Stop" : "Record"}
      </Button>

      {audioUrl != null && recording === false && (
        <audio
          className={styles.audio}
          controls
          autoPlay
          src={audioUrl}
        ></audio>
      )}

      {props.recordingState === "finished" && (
        <>
          <TextField
            className={styles.margin}
            id="outlined-basic"
            label="Name (Optional)"
            variant="outlined"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          />
          <TextField
            className={styles.margin}
            id="outlined-basic"
            label="Location (Optional)"
            variant="outlined"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
        </>
      )}

      <Button
        className={styles.margin}
        variant="contained"
        disabled={props.recordingState !== "finished"}
        color={"primary"}
        startIcon={<Publish />}
        onClick={() => {
          uploadAudio();
        }}
      >
        Submit
      </Button>

      {props.recordingState === "uploading" && (
        <>
          <CircularProgress className={styles.margin} />
          Uploading
        </>
      )}

      {props.recordingState === "saved" && audioRecordingDetails != null && (
        <Alert
          className={styles.margin}
          onClose={() => {
            setAudioRecordingDetails(null);
          }}
        >
          Your recording for "{audioRecordingDetails.prompt}" was submitted.
        </Alert>
      )}

      {props.recordingState === "saved" && error != null && (
        <Alert
          color="error"
          className={styles.margin}
          onClose={() => {
            setError(null);
          }}
        >
          {error}
        </Alert>
      )}
    </div>
  );
}
